/*eslint-disable */
import {mapGetters} from 'vuex';
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';

export default {
  name: 'newCourseListSmall',
  data () {
    return {
      clickloader: true,
      loader: true,
      newCourses: {},
      options:{
        height:'calc(100vh)'
      },
      
      
    }
  },
  components: { 
  },
  computed: {
    
  },
  mounted () {
    this.$store.dispatch('getcourselistByCat', {id:this.$route.params.courseid})
    .then((res) => {
      if(res.data.code == '2000'){
        this.clickloader = false;
        this.loader= false,
        this.newCourses = res.data.data.results
      }
      if(res.status == '400'){
        this.loader = true;
      }
    })
    .catch((err) => {
    })
  }, 
  methods: {
    getImgUrl(pic) {
        return require('./../../assets/images/'+pic)
    },
    enrollcourse(id){
      this.clickloader = true;
     let data= { course: id }
      this.$store.dispatch('setEnrollNewCourse', data)
      .then((res) => {
        if(res.data.code == '3017'){
          toast.success(res.data.msg);
          this.$store.dispatch('getcourselist').then((res) => {
            this.clickloader = false;
            return this.newCourses = this.$store.state.userCourses.latestCourseState.results;
          
          }).catch((err) => {
           //   console.log(err);
          });
        }
      })
      .catch((err) => {
       // console.log(err);
      })
    },
    showDescription(id, type){
      this.clickloader = true;
     if(type == 1){
      this.$router.push('/courses/'+id+'/');
      this.$store.dispatch('getSingleCourseDetail', {courseid: id}).then((res) => {
        if(res.status = 200){
          this.clickloader = false;
        }else{
          this.clickloader = true;
        }
      })
     }else{
      this.$router.push('/interview/courses/'+id+'/');
     }
    }
   
  },
  updated() {
    
  },
  watch:{
   
  }
}
